import React from 'react';
import _ from 'lodash';

const IsCellEqual = (prevProps, newProps) => {
  const p = prevProps.tdElement.props;
  const n = newProps.tdElement.props;
  
  return p.className === n.className
    && prevProps.Id === newProps.Id
    && prevProps.field === newProps.field
    && _.isEqual(prevProps.value, newProps.value)
    && _.isEqual(p.children, n.children) 
    && _.isEqual(p.style, n.style);
}

export const MemoCell = React.memo((props) => {
  const { tdElement } = props;  
  return tdElement;
}, IsCellEqual);